<template>
  <div>
    <v-dialog v-model="altaNuevoPresriptor" persistent max-width="60vh">
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="altaNuevoPresriptor = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-title class="justify-center">
          Alta de prescriptor
        </v-card-title>
        <v-card-text class="text-center">
          {{ nombreNuevoPrescriptor }}
          <v-text-field
            hide-details
            outlined
            label="Mat.Provincial"
            dense
            v-model="matProvincial"
          ></v-text-field>
          <v-text-field
            hide-details
            outlined
            label="Mat.Municipal"
            dense
            v-model="matMunicipal"
          ></v-text-field>
          <v-btn small color="yellow" @click="GuardarNuevoPrescriptor">
            Guardar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col md="12">
        <v-autocomplete
          v-model="select"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          :filter="filterObject"
          item-text="RAZON_SOCI"
          item-value="Id"
          cache-items
          flat
          hide-details
          label=""
          placeholder="Nombre | Razon Social | CUIT"
          outlined
          dense
          persistent-hint
          return-object
          :readonly="readonly"
          @change="selected"
        >
          <template v-slot:label="data">
            {{ data.item.nombreefector }}
          </template>
          <template v-slot:item="data">
            <v-list-item-content
              :title="'Planes: '+ data.item.Efector_Plan.map((x) => plan(x.Id_Plan)).join('-')"
              :style="
                data.item.incluyeplanAfiliado
                  ? { color: 'green' }
                  : { color: 'red' }
              "
            >
              <v-list-item-title>
                {{ data.item.nombreefector }} ({{ data.item.RAZON_SOCI }})
              </v-list-item-title>
              <v-list-item-subtitle
                >CUIT: {{ data.item.CUIT }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-btn
              v-if="altaPrescriptor && nombreNuevoPrescriptor != ''"
              @click="altaNuevoPresriptor = true"
              color="green"
              x-small
            >
              Dar de Alta
            </v-btn>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/lib/API";
import { mapState } from "vuex";
import { debounce } from "../../lib/debounce";
export default {
  props: {
    auditoria: {
      type: Boolean,
      default: false,
    },
    entidad: { type: Object },
    readonly: { type: Boolean, default: false },
    altaPrescriptor: { type: Boolean, default: false },
    id_plan: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      seleccionado: false,
      nombreNuevoPrescriptor: "",
      altaNuevoPresriptor: false,
      matProvincial: "",
      matMunicipal: "",
    };
  },
  computed: {
    ...mapState("planes", ["Lista"]),
    icono() {
      let ret = "";
      if (this.nuevoPrescriptor) {
        ret = "mdi-content-save";
      }
      return ret;
    },
  },
  created() {
    this.debouncedFetch = debounce((newValue) => {
      if (newValue) {
        if (!this.seleccionado) {
          newValue = newValue.replace('/', '__')
          this.querySelections(newValue)
        } else {
          this.seleccionado = false
        }
      }
    }, 500)
  },
  watch: {
    search(val) {
      this.debouncedFetch(val)
      // if (val) {
      //   if (!this.seleccionado) {
      //     val = val.replace("/", "__");
      //     this.querySelections(val);
      //   } else {
      //     this.seleccionado = false;
      //   }
      // }
    },
    select() {
      if (this.select) {
        this.$emit("input", this.select);
      } else {
        this.$emit("input", undefined);
      }
    },
    entidad() {
      this.seleccionado = true;
      this.items.push(this.entidad);
      this.select = this.entidad;
    },
  },
  methods: {
    plan(id) {
      return this.Lista.find((x) => x.id_plan === id).Descripcion_plan;
    },
    querySelections(v) {
      if (v.length < 3) {
        return;
      }
      this.loading = true;
      let id_planBusco = this.id_plan;
      if (this.auditoria) {
        id_planBusco = 0;
      }
      API.Efector.Buscar(v, id_planBusco).then((data) => {
        this.loading = false;

        data = data.map((p) => ({
          ...p,
          incluyeplanAfiliado:
            p.Efector_Plan.findIndex((x) => x.Id_Plan === this.id_plan) > -1,
        }));
        this.items = data;
      });
      if (this.altaPrescriptor) {
        if (this.items.length == 0) {
          this.nuevoPrescriptor = true;
          this.nombreNuevoPrescriptor = v.toUpperCase();
        } else {
          this.nuevoPrescriptor = false;
        }
      }
      this.loading = false
    },
    filterObject(item, queryText, itemText) {
      if (queryText) {
        return (
          item.RAZON_SOCI.toLocaleLowerCase().indexOf(
            queryText.toLocaleLowerCase()
          ) > -1 ||
          item.CUIT.toString().indexOf(queryText) > -1 ||
          item.nombreefector
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        );
      }
    },
    selected() {
      this.seleccionado = true;
    },
    async GuardarNuevoPrescriptor() {
      if (this.matMunicipal != "" || this.matProvincial != "") {
        this.select = await API.Efector.GuardarNuevoPrescriptor(
          this.nombreNuevoPrescriptor,
          this.matMunicipal,
          this.matProvincial
        );
      }
    },
  },
};
</script>
